/** 사이드바·모바일 메뉴의 '관련 누리집 링크' 섹션 (언어별 라벨) */
export const RELATED_SITE_MENU_LABELS = [
  '관련 누리집 링크',
  'Related Website Links',
  '関連ウェブサイトリンク',
  '相关网站链接',
] as const;

/** 메뉴 항목 표시명(언어별) → URL */
export const RELATED_SITE_URL_BY_LABEL: Record<string, string> = {
  // 한국어
  '대표누리집': 'https://www.sejong.go.kr',
  '통합예약시스템': 'https://onestop.sejong.go.kr',
  '도서관 누리집': 'https://lib.sejong.go.kr',
  '부동산 공시가격 알리미': 'https://www.realtyprice.kr',
  // English
  'Official Website': 'https://www.sejong.go.kr',
  'Integrated Reservation System': 'https://onestop.sejong.go.kr',
  'Library Website': 'https://lib.sejong.go.kr',
  'Official Land Price Notice': 'https://www.realtyprice.kr',
  // 日本語
  '代表ホームページ': 'https://www.sejong.go.kr',
  '統合予約システム': 'https://onestop.sejong.go.kr',
  '図書館ホームページ': 'https://lib.sejong.go.kr',
  '不動産公示価格通知': 'https://www.realtyprice.kr',
  // 中文
  '代表网站': 'https://www.sejong.go.kr',
  '综合预约系统': 'https://onestop.sejong.go.kr',
  '图书馆网站': 'https://lib.sejong.go.kr',
  '房地产公示价格通知': 'https://www.realtyprice.kr',
};

export function getRelatedSiteUrl(itemLabel: string): string {
  return RELATED_SITE_URL_BY_LABEL[itemLabel] ?? '';
}

export function isRelatedSiteLink(itemLabel: string): boolean {
  return itemLabel in RELATED_SITE_URL_BY_LABEL;
}

export function isRelatedSiteMenuLabel(menuLabel: string): boolean {
  return (RELATED_SITE_MENU_LABELS as readonly string[]).includes(menuLabel);
}
